// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/@kmijs+bundler-compiled@0.0.8/node_modules/@kmijs/bundler-compiled/compiled/css-loader/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/@kmijs+bundler-compiled@0.0.8/node_modules/@kmijs/bundler-compiled/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".body-container___DJV3I {\n  min-height: 400rem;\n}\n", "",{"version":3,"sources":["webpack://./../../features/mpc-common/src/features/useAddEquityModal/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF","sourcesContent":[".body-container {\n  min-height: 400px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body-container": "body-container___DJV3I"
};
export default ___CSS_LOADER_EXPORT___;
